import { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'

import { selectUser } from '../../../reducers/UserReducer'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { getContactPersonSchoolSpecialities, getContactPersonSpecialities } from '../../../utils/api/users'
import SmartTable, { SmartTableDataTypes } from '../../../Components/shared/SmartTable'
import { isSchoolMaccsUser } from '../../../utils/roles'
import { isArray } from 'lodash'
import { isObject } from '../../../utils'

const getSpecialityYearName = specialityYear => ({ name: specialityYear.specialityName + ' (' + specialityYear.studyYearName + ')', id: specialityYear.id })

const ContactPersonSpecialities = ({ contactPerson, onClose }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [specialityYears, setSpecialityYears] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (contactPerson !== null) {
      setLoading(true)

      if (isSchoolMaccsUser(user)) {
        if (isArray(contactPerson.institutions) && contactPerson.institutions.length > 0) {
          getContactPersonSpecialities(user, contactPerson, { institution: contactPerson.institutions[0].id }).then(({ data }) => {
            setSpecialityYears(data.map(getSpecialityYearName))
            setLoading(false)
          })
        } else {
          getContactPersonSchoolSpecialities(user, contactPerson, { school: user.school.id }).then(({ data }) => {
            setSpecialityYears(data.map(schoolSpeciality => getSpecialityYearName(schoolSpeciality.specialityYear)))
            setLoading(false)
          })
        }
      } else {
        if (isObject(contactPerson.school)) {
          getContactPersonSchoolSpecialities(user, contactPerson, { school: contactPerson.school.id }).then(({ data }) => {
            setSpecialityYears(data.map(schoolSpeciality => getSpecialityYearName(schoolSpeciality.specialityYear)))
            setLoading(false)
          })
        } else {
          getContactPersonSpecialities(user, contactPerson, { institution: user.institutions[0].id }).then(({ data }) => {
            setSpecialityYears(data.map(getSpecialityYearName))
            setLoading(false)
          })
        }
      }
    } else {
      setSpecialityYears([])
    }
  }, [contactPerson, user.id])

  const COLUMNS = [
    {
      type: SmartTableDataTypes.STRING,
      name: t('Specialities'),
      key: 'name'
    }
  ]
  return (
    <SmartTable
      loading={loading}
      columns={COLUMNS}
      data={specialityYears}
      noDataText={t('Without speciality')}
    />
  )
}

export default ContactPersonSpecialities
